import { Component } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'prox-verify-proceed',
  template: `
    <div [innerHTML]="message"></div>
    <div class="justify-content-end mt-4 flex">
      <div class="mr-2 flex">
        <button
          (click)="onProceed()"
          pButton
          type="button"
          label="Proceed"
          icon="pi pi-check"
          class="p-button-raised"
          id="verifyProceedOkBtn"
        ></button>
      </div>

      <div class="flex pr-2">
        <button
          (click)="onCancel()"
          pButton
          type="button"
          icon="pi pi-times"
          label="Cancel"
          class="p-button-raised"
          id="verifyProceedCancelBtn"
        ></button>
      </div>
    </div>
  `,
  standalone: false,
})
export class VerifyProceedComponent {
  /** Message may contain limited HTML (b, br, i, etc.). Sanitized at construction time. */
  message: SafeHtml;

  constructor(
    private ref: DynamicDialogRef,
    private config: DynamicDialogConfig,
    sanitizer: DomSanitizer,
  ) {
    this.message = sanitizer.bypassSecurityTrustHtml(config.data.message ?? '');
  }

  async onProceed() {
    this.ref.close(true);
  }

  onCancel() {
    this.ref.close(false);
  }
}
